import { useAppSelector } from '../index';

export const useUploadProgress = () =>
  useAppSelector((state) => state.uploadProgress.progress);
